import { ExportReportType } from '~/exportReport/exportReportType';

export const isReportTypePolygon = (type: ExportReportType) => (
  type === ExportReportType.Polygon || type === ExportReportType.DriveTimePolygon
);
